let _config = {};

_config['API_HOST'] = 'http://localhost:3000';
_config['STATIC_ASSET_HOST'] = 'http://localhost:8080';

module.exports = _config;


// WEBPACK FOOTER //
// ../config/dev.js